import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import api from "@/lib/api";

/**
 * FAQ page with JSON-LD FAQPage schema — critical for AI search visibility (ChatGPT, Perplexity, Gemini).
 */
export default function FAQ() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/faq").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  const url = `${window.location.origin}/faq`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <div data-testid="faq-page" className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-14">
      <Helmet>
        <title>FAQ - Domande frequenti | HostMarket</title>
        <meta name="description" content="Tutte le risposte su HostMarket, la piazza dei professionisti degli affitti brevi: piani, pagamenti, privacy, home spotlight, contatti." />
        <link rel="canonical" href={url} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <div className="text-xs uppercase tracking-[0.25em] text-[#FFBE00] mb-3">· Centro assistenza</div>
      <h1 className="font-heading font-black text-4xl sm:text-5xl mb-3">Domande <span className="text-[#FFBE00]">frequenti</span>.</h1>
      <p className="text-zinc-400 mb-8">Non trovi quello che cerchi? <Link to="/contatti" className="underline hover:text-[#FFBE00]">Scrivici</Link>.</p>

      <div className="space-y-2">
        {items.map((it, i) => {
          const isOpen = open === i;
          return (
            <details
              key={i}
              open={isOpen}
              onToggle={(e) => setOpen(e.target.open ? i : null)}
              className="hm-card overflow-hidden"
              data-testid={`faq-item-${i}`}
            >
              <summary className="p-4 md:p-5 cursor-pointer font-bold text-base md:text-lg flex items-center justify-between gap-3 hover:text-[#FFBE00]">
                <span>{it.q}</span>
                <i className={`fas fa-chevron-down text-[#FFBE00] transition-transform ${isOpen ? "rotate-180" : ""}`}></i>
              </summary>
              <div className="px-4 md:px-5 pb-5 pt-0 text-zinc-300 leading-relaxed">{it.a}</div>
            </details>
          );
        })}
      </div>

      <div className="mt-14 p-6 hm-card text-center">
        <h2 className="font-heading font-bold text-xl">Non hai trovato la tua risposta?</h2>
        <p className="text-sm text-zinc-400 mt-2">Il team di HostMarket ti risponde entro 24 ore.</p>
        <Link to="/contatti" className="mt-5 inline-block px-5 py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase text-xs">Contattaci →</Link>
      </div>
    </div>
  );
}
